import { Injectable } from '@angular/core';
import { PaetepUserApi } from '../api/paetep-user.api';

@Injectable()
export class PaetepUserService {

    constructor(private userApi: PaetepUserApi) { }

    getBasicUser = (userId: string) => 
        this.userApi.getBasicUser(userId);

    getSupervisors = (userId: string) =>
        this.userApi.getSupervisors(userId);

    getUserRolesByPriority = (userId: string) =>
        this.userApi.getUserRolesByPriority(userId);

    getSupervisorsForBuilding = (buildingId: number) =>
      this.userApi.getSupervisorsForBuilding(buildingId);

}
